import NavigationGroup from "./NavigationGroup";
import { Typography } from "@mui/material";
import { boxShadow } from "../../../../../assets/jss/material-dashboard-pro-react";
import avatar from "../../../../../assets/img/default-avatar.png";
import NavigationItem from "./NavigationItem";
import { AccountCircle, ExitToApp, LockOpen } from "@mui/icons-material";
import React from "react";
import axios from "axios";
import { useNavigate } from "react-router";
import { readCookie } from "../../../../../store/reducers/translations";
import { LanguageAvailableInConfig } from "../../../../../components/TranslatableEditor/translations_definitions";
import { MysqlID } from "../../../../../store/api/upsellApi";
import { toast } from "react-toastify";

function annotatedUsername(username: string) {
  const expiration = readCookie("totp_expiration");
  let usernameText = `${username}`;
  if (expiration) {
    usernameText += ` (${expiration})`;
  }
  return usernameText;
}

type User = {
  id: MysqlID;
  username: string;
  Voornaam: string;
  Achternaam: string;
  lang: LanguageAvailableInConfig;
  isImpersonating: boolean;
};

export const UserProfileNavigationItem = ({ user }: { user: Pick<User, "isImpersonating" | "username"> }) => {
  const navigate = useNavigate();

  return (
    <NavigationGroup
      auth={null}
      icon={
        <div
          style={{
            width: "34px",
            height: "34px",
            borderRadius: "50%",
            overflow: "hidden",
            ...boxShadow,
            marginRight: 8,
          }}
        >
          <img
            alt={"..."}
            src={avatar}
            style={{
              width: "100%",
              verticalAlign: "middle",
              border: "0",
            }}
          />
        </div>
      }
      text={<Typography variant={"body2"}>{annotatedUsername(user.username)}</Typography>}
    >
      <NavigationItem
        auth={null}
        icon={<AccountCircle />}
        text={{ tKey: "menu.user.profile", tDefault: "Profiel" }}
        to={"/manager/profiel"}
      />
      <NavigationItem
        auth={null}
        icon={<LockOpen />}
        text={{ tKey: "menu.user.2fa", tDefault: "2FA" }}
        to={"/manager/2fa/renew"}
      />
      {user.isImpersonating ? (
        <NavigationItem
          auth={null}
          icon={<ExitToApp />}
          onClick={async () => {
            try {
              await axios.post("/core/gebruikers/stopImpersonate");
              window.location.reload();
            } catch (e) {
              console.error(e);
              toast.error("Was unable to stop impersonating");
            }
          }}
          text={{
            tKey: "menu.user.stopimpersonating",
            tDefault: "Stop impersonating",
          }}
        />
      ) : null}
      <NavigationItem
        auth={null}
        icon={<ExitToApp />}
        onClick={async () => {
          const response = await axios.post("logout");
          if (response.data.success) {
            navigate("/manager/login");
          }
        }}
        text={{
          tKey: "menu.user.logout",
          tDefault: "Logout",
        }}
      />
    </NavigationGroup>
  );
};
